import React, { useEffect, useState } from "react";
import moment, { Moment } from "moment";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { KeyboardDatePicker } from "@material-ui/pickers";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Trad } from "../../components/";

const datePickerTheme = createTheme({
    palette: {
        primary: {
            main: "#4189c7"
        },
        secondary: {
            main: "#000"
        }
    },
    overrides: {
        MuiFormLabel: {
            root: {
                fontSize: "0.9285714285714286rem"
            }
        },
        MuiInputBase: {
            root: {
                fontSize: "13px"
            }
        }
    }
});

interface IDateFieldProps {
    Label: string;
    Name: string;
    OnChange: (e: string, val: string | Date) => void;
    Value: Date | string | undefined;
    Disabled?: boolean;
    OnChangeDerogation?: (e: React.FormEvent<any>) => void;
}

export const _DateField: React.FC<IDateFieldProps> = ({ Disabled, Label, Name, Value, OnChange, OnChangeDerogation }) => {
    const [selectedDate, handleDateChange] = useState<Moment | null>(null);

    useEffect(() => {
        handleDateChange(Value ? moment(Value) : null);
    }, [Value]);

    return (
        <>
            {OnChangeDerogation && <FormControlLabel control={<Checkbox onChange={OnChangeDerogation} name={Name} />} label={Trad.Trad(Label)} />}
            <ThemeProvider theme={datePickerTheme}>
                <KeyboardDatePicker
                    autoOk
                    fullWidth
                    color="secondary"
                    variant="inline"
                    disabled={Disabled}
                    format="DD/MM/YYYY"
                    name={Name}
                    label={OnChangeDerogation ? "" : Trad.Trad(Label)}
                    value={selectedDate}
                    onChange={date => {
                        if (!date) {
                            OnChange(Name, "");
                        } else if (date.isValid()) {
                            const val = date.toDate();
                            OnChange(Name, new Date(Date.UTC(val.getFullYear(), val.getMonth(), val.getDate(), 0, 0, 0, 0)));
                        } else {
                            handleDateChange(date);
                        }
                    }}
                    invalidDateMessage={Trad.Trad("Invalid Date Format")}
                    KeyboardButtonProps={{
                        "aria-label": "change date"
                    }}
                />
            </ThemeProvider>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/form/DateField.tsx